import {IssueGroupingKey} from '@domain/stoppages'

import type {Filters} from '../components'

export const PERFORMANCE_KPI_REQUEST_STALE_TIME = 1000 * 60 * 15 // 15 minutes

export const TOP_ISSUES_SORT_BY = 'sortBy'
export const TOP_ISSUES_GROUP_BY = 'groupBy'
export const FAILURE_STOPPAGE = 'failureStoppage'
export const STOPPAGE_DURATION = 'stoppageDuration'

export const DOWNTIME_DETAILS_FILTER_OPTIONS: Record<IssueGroupingKey, Filters> = {
  [IssueGroupingKey.STOPPAGE_CODE]: ['failures', 'mainEquipmentNumbers', 'equipmentNumbers'],
  [IssueGroupingKey.TIME_INTERVAL]: [
    'failures',
    'mainEquipmentNumbers',
    'equipmentNumbers',
    'stoppageCodes'
  ],
  [IssueGroupingKey.STOPPED_MAIN_EQUIPMENT]: [
    'failures',
    'mainEquipmentNumbers',
    'equipmentNumbers',
    'stoppageCodes'
  ],
  [IssueGroupingKey.MAIN_EQUIPMENT]: ['failures', 'equipmentNumbers', 'stoppageCodes'],
  [IssueGroupingKey.EQUIPMENT_NUMBER]: ['failures', 'mainEquipmentNumbers', 'stoppageCodes']
}

export const DOWNTIME_DETAILS_FOR_MAIN_EQUIPMENT_AND_CODE_FILTER_OPTIONS = {
  [IssueGroupingKey.MAIN_EQUIPMENT]: ['failures', 'equipmentNumbers'],
  [IssueGroupingKey.EQUIPMENT_NUMBER]: ['failures'],
  [IssueGroupingKey.STOPPED_MAIN_EQUIPMENT]: [
    'failures',
    'mainEquipmentNumbers',
    'equipmentNumbers'
  ]
} as const satisfies Record<string, Filters>

export const DOWNTIME_STATISTICS_PATH = 'downtime-statistics'
export const DOWNTIME_OVERVIEW_PATH = 'overview'
export const DOWNTIME_STOPPAGES_PATH = 'stoppages'
export const DOWNTIME_STOPPAGE_DETAILS_PATH = ':groupType/:groupId'
export const DOWNTIME_STOPPAGE_DETAILS_FOR_CODE_PATH = 'stoppageCode/:stoppageCode'

export const DowntimeStatisticsViewToggleOptions = {
  YTM_VIEW: 'yearToMonthKpis',
  MTM_VIEW: 'monthToMonthKpis'
} as const

export type DowntimeStatisticsViewToggleOption =
  (typeof DowntimeStatisticsViewToggleOptions)[keyof typeof DowntimeStatisticsViewToggleOptions]

export const DOWNTIME_STATISTICS_TOGGLE_VIEWS = Object.values(
  DowntimeStatisticsViewToggleOptions
) as DowntimeStatisticsViewToggleOption[]
